import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import Link from 'components/common/Link'
import routes from 'router/routes'
import { createDateFromString, formatDateToURLFormatDateFns } from 'utils/date'
import { extractNameInitials } from 'utils/string'
import { isValidHex } from 'utils/validations'

type Props = {
  routeName?: string | null
  routeColor?: string | null
  serviceDate?: string | null
  sequence?: string | number | null
  disableRedirect?: boolean
  openInNewTab?: boolean
}

const RouteChip: React.FC<Props> = ({
  routeName = '',
  routeColor,
  serviceDate,
  sequence = 0,
  disableRedirect = false,
  openInNewTab = false,
}) => {
  const theme = useTheme()
  const formattedBgcolor = routeColor && isValidHex(routeColor) ? routeColor : theme.palette.background.black
  const color = theme.palette.getContrastText(formattedBgcolor)
  const routeUrl = `${routes.app.routes}?service_date=${formatDateToURLFormatDateFns(createDateFromString(serviceDate))}`
  const initials = extractNameInitials(routeName)

  const chip = (
    <Chip
      avatar={<Avatar sx={{ backgroundColor: formattedBgcolor }}>{initials}</Avatar>}
      label={Number(sequence) > 0 ? `${routeName} | ${sequence}` : routeName}
      size="small"
      sx={{
        '& .MuiChip-avatar': {
          color,
        },
      }}
      variant="outlined"
    />
  )

  if (disableRedirect) {
    return chip
  }

  return (
    <Link
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      target={openInNewTab ? '_blank' : undefined}
      to={routeUrl}
      underline="none"
    >
      {chip}
    </Link>
  )
}

export default RouteChip
